export const pcStyle = `/* el-dialog、MessageBox 公共样式 */
.el-dialog {
    border-radius: 4px !important;
    min-width: 432px !important;
    max-width: 960px !important;
    margin-top: 0 !important;
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.el-message-box {
    width: 432px !important;
    border-radius: 4px;
    padding-bottom: 0 !important;
    border: none !important;
}
/* header */
.el-dialog > .el-dialog__header,
.el-message-box__header {
    padding: 16px 24px !important;
    font-weight: bold;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E1E5EB !important;
    font-size: 16px;
}
.el-message-box__title {
    height: 24px;
    display: flex;
    align-items: center;
}
.el-dialog__title,
.el-message-box__title {
    color: #333 !important;
    font-size: 16px !important;
}
.el-dialog__headerbtn,
.el-message-box__headerbtn {
    width: 25px;
    height: 25px;
    top: 15px !important;
    right: 18px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.el-dialog__headerbtn > .el-icon-close,
.el-message-box__headerbtn > .el-icon-close {
    font-size: 18px;
    color: #979AA0 !important;
}
.el-dialog__headerbtn:hover,
.el-message-box__headerbtn:hover{
    background-color: #F2F3F5;
    border-radius: 4px;
}
/* body */
.el-dialog > .el-dialog__body,
.el-message-box__content {
    padding: 24px !important;
    font-size: 14px !important;
    color: #333 !important;
    max-height: 500px;
    overflow-y: auto;
}
/* footer */
.el-dialog__footer,
.el-message-box__btns {
    padding: 14px 24px !important;
    border-top: 1px solid #E1E5EB !important;
}
.el-dialog__footer .el-button,
.el-message-box__btns .el-button {
    height: 32px !important;
    padding: 0 15px !important;
    font-size: 14px !important;
    border-radius: 4px;
}
/* 弹窗滚动条 */
.el-dialog ::-webkit-scrollbar{
    width: 4px;
    background-color: #F1F1F1;
}
.el-dialog ::-webkit-scrollbar-thumb {
    background-color: #C1C1C1; 
}
`


// WEBPACK FOOTER //
// ./src/pop.js